/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import { JobContractDaysPeriodType } from '../../system-vars/system-vars.dto';
import {
  ContracturalCompletionRequestDto,
  ContracturalCompletionResponseDto,
  JobDatesTabInfoDto,
} from './job-dates.dto';

export const JobDatesInfoMapper = entity<JobDatesTabInfoDto>({
  depositDate: date(DateFormat.Date),
  csDate: date(DateFormat.Date),
  csSignedByClientDate: date(DateFormat.Date),
  csSignedByOfficeDate: date(DateFormat.Date),
  financeApprovedDate: date(DateFormat.Date),
  contractDate: date(DateFormat.Date),
  saleDate: date(DateFormat.Date),
  councilApprovedDate: date(DateFormat.Date),
  authToCommenceDate: date(DateFormat.Date),
  cocIssueDate: date(DateFormat.Date),
  contractStartDate: date(DateFormat.Date),
  initialClaimDate: date(DateFormat.Date),
  contracturalCompletionDate: date(DateFormat.Date),
  constructionPeriodIncludes: enumeration(JobContractDaysPeriodType),
  completedDate: date(DateFormat.Date),
  finalClaimDate: date(DateFormat.Date),
  notProceedingDate: date(DateFormat.Date),
  handoverDate: date(DateFormat.Date),
  finalizedDate: date(DateFormat.DateTime),
  scheduleStartDate: date(DateFormat.DateTime),
  scheduleCompleteDate: date(DateFormat.DateTime),
  scheduleSlabDate: date(DateFormat.Date),
});

export const contracturalCompletionRequestMappper = entity<ContracturalCompletionRequestDto>({
  contractStartDate: date(DateFormat.DateTime),
});
export const contracturalCompletionResponseMapper = entity<ContracturalCompletionResponseDto>({
  contracturalCompletionDate: date(DateFormat.Date),
});
